const MEMBERSHIP_SELECTION_KEY = "selectedMembershipPlan";

export const getMembershipSelectionRaw = (): string | null => {
  if (typeof window === "undefined") {
    return null;
  }

  try {
    return window.sessionStorage.getItem(MEMBERSHIP_SELECTION_KEY);
  } catch {
    return null;
  }
};

export const storeMembershipSelection = (value: unknown) => {
  if (typeof window === "undefined") {
    return;
  }

  try {
    if (value === undefined || value === null) {
      window.sessionStorage.removeItem(MEMBERSHIP_SELECTION_KEY);
      return;
    }

    const serialized =
      typeof value === "string" ? value : JSON.stringify(value);
    window.sessionStorage.setItem(MEMBERSHIP_SELECTION_KEY, serialized);
  } catch (error) {
    console.warn("[membership] Unable to persist membership selection", error);
  }
};

export const clearMembershipSelection = () => {
  if (typeof window === "undefined") {
    return;
  }

  try {
    window.sessionStorage.removeItem(MEMBERSHIP_SELECTION_KEY);
  } catch (error) {
    console.warn("[membership] Unable to clear membership selection", error);
  }
};

export { MEMBERSHIP_SELECTION_KEY };
